<template>
    <v-card outlined v-if="recipientsCount > 0">
        <v-data-table
                class="elevation-0"
                :headers="headers"
                :items="items"
                :items-per-page="15"
                :footer-props="dataTableFooterProps"
                :search="dataTableSearch"
                :custom-filter="dataTableCustomFilter"
                :loading="isBusy"
                :loading-text="$t('common.loading_table_data')"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-text-field
                            v-model="dataTableSearch"
                            prepend-inner-icon="mdi-magnify"
                            :placeholder="$t('common.filter')"
                            outlined
                            dense
                            hide-details
                    />
                </v-toolbar>
            </template>
            <template v-slot:item.address_string="{ item }">
                {{ item.address_string }}
            </template>
            <template v-slot:item.email="{ item }">
                <v-text-field
                        v-if="!readonly"
                        type="email"
                        v-model="item.email"
                        :error="!item.email"
                        outlined
                        dense
                        single-line
                        hide-details
                        class="my-1"
                        @input="onRefreshRecipient(item)"
                />
                <template v-else>
                    {{ item.email ? item.email : '-' }}
                </template>
            </template>
            <template v-slot:item.phone="{ item }">
                <v-text-field
                        v-if="!readonly"
                        type="tel"
                        v-model="item.phone"
                        :error="!item.phone"
                        outlined
                        dense
                        single-line
                        hide-details
                        class="my-1"
                        @input="onRefreshRecipient(item)"
                />
                <template v-else>
                    {{ item.phone ? item.phone : '-' }}
                </template>
            </template>
            <template v-slot:item.actions="{ item }" v-if="!readonly">
                <span class="text-no-wrap">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click="onDelete(item)" v-on="on" color="error">
                                <v-icon>
                                    mdi-trash-can
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('tooltip.recipients.delete') }}</span>
                    </v-tooltip>
                </span>
            </template>
        </v-data-table>
    </v-card>
    <v-alert v-else icon="mdi-information" prominent text type="info">
        {{ $t('recipients.no_recipient') }}
    </v-alert>
</template>

<script>
import SnackbarMixin from '@/mixins/SnackbarMixin'
import ShoppingCartMixin from '@/mixins/ShoppingCartMixin'
import DataTableMixin from '@/mixins/DataTableMixin'

export default {
    name: "RecipientsTable",
    mixins: [SnackbarMixin, ShoppingCartMixin, DataTableMixin],
    props: {
        userId: {
            type: Number,
            required: true
        },
        warehouseId: {
            type: Number,
            required: true
        },
        storeModule: {
            type: String,
            required: false,
            default: () => "shoppingCart"
        },
        readonly: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        isBusy () {
            return false;
        },
        headers () {
            return [
                {
                    text: this.$t('recipients.recipient'),
                    value: 'address_string'
                },
                {
                    text: this.$t('recipients.email'),
                    value: 'email'
                },
                {
                    text: this.$t('recipients.phone'),
                    value: 'phone'
                },
                {
                    text: '',
                    value: 'actions',
                    align: 'end',
                    sortable: false
                }
            ];
        },
        items () {
            return this.getRecipientsInCart(this.userId, this.warehouseId, this.storeModule);
        },
        recipientsCount () {
            return this.items.length;
        }
    },
    watch: {
        items: {
            deep: true,
            immediate: true,
            handler(items) {
                this.$emit("isValid", items.every(item => Boolean(item.phone && item.email)));
            }
        }
    },
    methods: {
        onRefreshRecipient (item) {
            this.addRecipientToShoppingCart(this.userId, this.warehouseId, item, this.storeModule);
        },
        onDelete (item) {
            if (!confirm(this.$t('confirm.delete_recipient'))) {
                return;
            }

            this.removeRecipientFromCart(this.userId, this.warehouseId, item.address_id, this.storeModule);
        }
    }
}
</script>
